import React from 'react';
import { TouchableOpacity, Text, StyleSheet, Dimensions, Pressable } from 'react-native';

import Icon from '../Icon';
import { CommonProperties, Color } from '../../styles';
import { scaleVertically } from '../../utils/scale.utils';

const { height: screenHeight } = Dimensions.get('window');

const AddReceiptDropDown = ({
  receiptsComponentHeight = 0,
  optionsArrayState,
  aboveElements = true,
  onClose = () => {},
}) => {
  const position = aboveElements ? 'absolute' : 'relative';
  return (
    <Pressable
      style={[
        styles.optionsContainer,
        { top: receiptsComponentHeight + scaleVertically(10), position },
      ]}
      onPress={onClose}
    >
      {optionsArrayState.map((option) => (
        <TouchableOpacity key={option.label} style={styles.option} onPress={option.onPress}>
          <Text style={styles.optionText}>{option.label}</Text>
          <Icon name={option.icon} size={30} style={styles.menuIcon} />
        </TouchableOpacity>
      ))}
    </Pressable>
  );
};

const styles = StyleSheet.create({
  optionsContainer: {
    left: 0,
    right: 0,
    zIndex: 999,
    backgroundColor: Color.transparent,
    height: screenHeight * 0.6,
  },
  option: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 10,
    backgroundColor: Color.lightgray,
    ...CommonProperties.justifyBetween,
    ...CommonProperties.borderRadius2,
    ...CommonProperties.mx4,
    borderBottomWidth: 1,
    borderBottomColor: Color.grayText,
    shadowColor: Color.black,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 4,
    elevation: 5, // For Android shadow
  },
  optionText: {
    ...CommonProperties.h2,
    ...CommonProperties.ml5,
  },
  menuIcon: {
    ...CommonProperties.mr5,
  },
});

export default AddReceiptDropDown;
